import { render, staticRenderFns } from "./DossierSOPs.vue?vue&type=template&id=74192a10&scoped=true&"
import script from "./DossierSOPs.vue?vue&type=script&lang=js&"
export * from "./DossierSOPs.vue?vue&type=script&lang=js&"
import style0 from "./DossierSOPs.vue?vue&type=style&index=0&id=74192a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74192a10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VSelect,VTextField,VTextarea})
